import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-canvas py-16 md:py-24" data-id="element-83" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-84" data-mp="1o3dim06d3rlc">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-2xl bg-rose-500 text-white" data-id="element-85" data-mp="2223g3gx3fta8">
          <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-86" data-mp="1x54ph8cn24gs" />
        </span>

        <h2 className="mt-7 font-display text-[2rem] font-extrabold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-87" data-mp="19fipwjsctn89">
          Garantía de 7 días
        </h2>

        <div className="mt-9 rounded-2xl bg-white px-6 py-9 shadow-soft ring-1 ring-gray-200 md:px-10" data-id="element-88" data-mp="1j52co0j6u18e">
          <p className="text-lg leading-relaxed text-gray-500 md:text-xl" data-id="element-89" data-mp="1edc0rq4lr5ev">
            Probá el Protocolo Octubre Rosa™ sin riesgo. Si durante los próximos 7 días sentís que el
            material no es lo que esperabas, simplemente escribinos y procesaremos el reembolso. Sin
            complicaciones. Sin preguntas.{' '}
            <span className="font-display font-extrabold text-ink" data-id="element-90" data-mp="oyqe49mubxjo">Tu riesgo es mínimo.</span>
          </p>
          <p className="mt-6 font-display text-lg font-extrabold leading-snug tracking-tight text-ink md:text-xl" data-id="element-91" data-mp="tx1oqmkymc2y">
            Accedés al material, lo revisás y decidís. Sabemos que funciona porque lo vimos en
            cientos de profesionales.
          </p>
        </div>
      </div>
    </section>;
}